// import moment from "moment";

import moment from "moment-timezone";

moment.tz("America/Bahia");

export default moment;
